var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBulkLoadExternalReport = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 0H12.2295C13.0437 0.000191274 13.8245 0.323948 14.4 0.9L17.127 3.633C17.6849 4.19388 17.9986 4.95241 18 5.7435V18C18 19.6569 16.6569 21 15 21H4.5C2.84315 21 1.5 19.6569 1.5 18V3C1.5 1.34315 2.84315 0 4.5 0ZM12.2295 1.5C12.6452 1.49994 13.044 1.66505 13.338 1.959L16.0635 4.6875C16.3423 4.96591 16.4992 5.34351 16.5 5.7375V18C16.5 18.8284 15.8284 19.5 15 19.5H4.5C3.67157 19.5 3 18.8284 3 18V3C3 2.17157 3.67157 1.5 4.5 1.5H12H12.2295ZM21 10.233C20.9982 9.4451 20.6843 8.69001 20.127 8.133L19.5 7.5V19.5C19.5335 21.1227 18.2457 22.4656 16.623 22.5H6.41551C6.94717 23.4258 7.9324 23.9976 9.00001 24H16.5C17.6686 24.0249 18.7993 23.5846 19.6432 22.7758C20.4872 21.967 20.9752 20.8561 21 19.6875V10.2375V10.233ZM15 15H4.5V16.5H15V15ZM6 6H7.5V13.5H6V6ZM10.5 7.5H9V13.5H10.5V7.5ZM12 6H13.5V13.5H12V6Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBulkLoadExternalReport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bulk-load-external-report.744814b1d2432e0b6253efbbaa3dce96.svg";